import { Injectable } from '@angular/core'
import { combineLatest, Observable } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { EntityConfigService } from '../../dto/services/entity-config.service'
import EntityUrlsUtils from '../../../utils/entity-urls.util'
import { DynamicRoutesService } from './dynamic-routes.service'

@Injectable({
  providedIn: 'root'
})
export class EntityLinkService {
  constructor(
    private dynRoutesService: DynamicRoutesService,
    private entityConfigService: EntityConfigService
  ) {}

  public getEntityLinkData$(values: {
    type: string
    id?: number
  }): Observable<{ url: string; queryParams: any; generic: boolean }> {
    const isMultiPage$ = this.entityConfigService
      .getConfig$(values.type)
      .pipe(map((config) => config?.viewType === 'multiPage'))

    const targetUrl$ = isMultiPage$.pipe(
      switchMap((isMultiPage) =>
        this.dynRoutesService.generateUrlForEntityType$({
          entityType: values.type,
          id: isMultiPage ? values.id : null
        })
      )
    )

    // this stuff is hardwired in here and should be moved to be more dynamic
    const targetParams$ = combineLatest([targetUrl$, isMultiPage$]).pipe(
      map(([url, isMultiPage]) => {
        //leading string of the url (filter is there to remove possible empty split-results from '//')
        const urlFirstPart = url.split('/').filter((x) => x != '')[0]
        return {
          queryParams: EntityUrlsUtils.generateQueryParamsForEntityType({
            entityType: values.type,
            checkForQueryParam: urlFirstPart?.startsWith('configuration'),
            id: !urlFirstPart.startsWith('entity') || !isMultiPage ? values.id : null,
            addToken: urlFirstPart.startsWith('configuration')
          }),
          generic: urlFirstPart.startsWith('configuration')
        }
      })
    )

    const result$ = combineLatest([targetUrl$, targetParams$]).pipe(
      map(([url, { queryParams, generic }]) => {
        return { url, queryParams, generic }
      })
    )

    return result$
  }
}
